import React from 'react';
import { HomeOutlined } from "@ant-design/icons"; // eslint-disable-line
import PropTypes from 'prop-types';
// eslint-disable-next-line no-undef
const { frontPage } = window.enervent.translations;

const Breadcrumbs = ({ parent, title }) => (
  <div className="breadcrumbs">
    <a className="breadcrumbs__home" href={frontPage}>
      <HomeOutlined />
    </a>
    <span className="breadcrumbs__separator">/</span>
    {parent && (
      <>
        <a href={parent.link}>
          <span className="breadcrumbs__crumb">{parent.title}</span>
        </a>
        <span className="breadcrumbs__separator">/</span>
      </>
    )}
    <span className="breadcrumbs__crumb breadcrumbs__crumb--current">
      {title}
    </span>
  </div>
);

Breadcrumbs.propTypes = {
  parent: PropTypes.shape({
    link: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default Breadcrumbs;
